interface NumberedBadgeProps {
  number: number | string;
  size?: 'xs' | 'small' | 'medium' | 'large';
  className?: string;
  bgColor?: string;
  borderColor?: string;
  textColor?: string;
}

const NumberedBadge = ({
  number,
  size = 'medium',
  className = '',
  bgColor = 'bg-primary-500',
  borderColor = 'border-white',
  textColor = 'text-white'
}: NumberedBadgeProps) => {
  const sizeClasses = {
    xs: {
      container: 'w-6 h-6 rounded-md',
      text: 'text-xs font-medium'
    },
    small: {
      container: 'w-7 h-7 rounded-md',
      text: 'text-sm font-medium'
    },
    medium: {
      container: 'w-8 h-8 rounded-lg',
      text: 'text-base font-semibold'
    },
    large: {
      container: 'w-10 h-10 rounded-lg',
      text: 'text-lg font-semibold'
    }
  };

  const currentSize = sizeClasses[size];

  return (
    <div
      className={`${currentSize.container} ${bgColor} border-2 ${borderColor} flex items-center justify-center ${textColor} ${className}`}
    >
      <span className={currentSize.text}>{number}</span>
    </div>
  );
};

export default NumberedBadge;
